<template>
    <div class="container">
        <div class="row">
            <!-- Regular Shows Section -->
            <div v-if="regularShows.length > 0" class="col-12">
                <div class="text-center fs-1 pt-5 pb-4 text-uppercase oswald-bold">
                    Regular Shows
                </div>
            </div>
            <div v-for="(show, index) in regularShows" :key="'regular-' + index"
                :class="`col-md-4 d-flex flex-column align-items-center justify-content-start pb-2 px-3 show-card`"
                :style="{ cursor: 'pointer', transitionDelay: `${index * 0.12}s` }"
                @click="goToShow(show)">

                <div class="position-relative">
                    <img :src="`${$API_ASSETS}${show.banner_image.id}?width=800&quality=80`" class="img-fluid py-2" />
                    <img v-if="show.family_friendly" :src="require('@/assets/familyFriendly.png')"
                        class="position-absolute" style="bottom: -15%; width: 25%; transform: translate(-150%,0%);" />
                    <img v-if="show.pay_what_you_can" :src="require('@/assets/pay-what-you-can.png')"
                        class="position-absolute" style="bottom: -15%; width: 25%; transform: translate(-100%,0%);" />
                </div>

                <div class="text-start">
                    <span class="fs-2 text-uppercase oswald-bold">{{ show.name }}</span>
                    <span class="fs-5 d-block oswald-bold">{{ show.date_text }}</span>
                    <p class="m-0 py-1">{{ show.description }}</p>
                    <p class="m-0 text-uppercase py-2">
                        <a :href="getShowLink(show)" class="cardlink" @click.stop>{{ getButtonText(show)
                            }} <i class="fa-solid fa-arrow-right"></i></a>
                    </p>
                </div>
            </div>

            <!-- Specialty Shows Section -->
            <div v-if="specialtyShows.length > 0" class="col-12">
                <div class="text-center fs-1 pt-5 pb-4 text-uppercase oswald-bold">
                    Specialty Shows
                </div>
            </div>
            <div v-for="(show, index) in specialtyShows" :key="'specialty-' + index"
                :class="`col-md-4 d-flex flex-column align-items-center justify-content-start pb-2 px-3 show-card`"
                :style="{ cursor: 'pointer', transitionDelay: `${index * 0.12}s` }"
                @click="goToShow(show)">

                <div class="position-relative">
                    <img :src="`${$API_ASSETS}${show.banner_image.id}?width=800&quality=80`" class="img-fluid py-2" />
                    <img v-if="show.family_friendly" :src="require('@/assets/familyFriendly.png')"
                        class="position-absolute" style="bottom: -15%; width: 25%; transform: translate(-150%,0%);" />
                    <img v-if="show.pay_what_you_can" :src="require('@/assets/pay-what-you-can.png')"
                        class="position-absolute" style="bottom: -15%; width: 25%; transform: translate(-100%,0%);" />
                </div>

                <div class="text-start">
                    <span class="fs-2 text-uppercase oswald-bold">{{ show.name }}</span>
                    <span class="fs-5 d-block oswald-bold">{{ show.date_text }}</span>
                    <p class="m-0 py-1">{{ show.description }}</p>
                    <p class="m-0 text-uppercase py-2">
                        <a :href="getShowLink(show)" class="cardlink" @click.stop>{{ getButtonText(show)
                            }} <i class="fa-solid fa-arrow-right"></i></a>
                    </p>
                </div>
            </div>

            <!-- Previous Shows Section -->
            <div v-if="previousShows.length > 0" class="col-12">
                <div class="text-center fs-1 pt-5 pb-4 text-uppercase oswald-bold previous-shows-toggle"
                    style="cursor: pointer;" @click="showPreviousShows = !showPreviousShows">
                    Previous Shows
                    <i :class="showPreviousShows ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'"
                        style="font-size: 1.5rem; margin-left: 0.5rem; vertical-align: middle;"></i>
                </div>
                <transition name="prev-shows">
                    <div v-if="showPreviousShows" class="row">
                        <div v-for="(show, index) in previousShows" :key="'previous-' + index"
                            class="col-md-4 d-flex flex-column align-items-center justify-content-start pb-2 px-3"
                            style="cursor: pointer;"
                            @click="goToShow(show)">

                            <div class="position-relative">
                                <img :src="`${$API_ASSETS}${show.banner_image.id}?width=800&quality=80`" class="img-fluid py-2" />
                                <img v-if="show.family_friendly" :src="require('@/assets/familyFriendly.png')"
                                    class="position-absolute" style="bottom: -15%; width: 25%; transform: translate(-150%,0%);" />
                                <img v-if="show.pay_what_you_can" :src="require('@/assets/pay-what-you-can.png')"
                                    class="position-absolute" style="bottom: -15%; width: 25%; transform: translate(-100%,0%);" />
                            </div>

                            <div class="text-start">
                                <span class="fs-2 text-uppercase oswald-bold">{{ show.name }}</span>
                                <span class="fs-5 d-block oswald-bold">{{ show.date_text }}</span>
                                <p class="m-0 py-1">{{ show.description }}</p>
                            </div>
                        </div>
                    </div>
                </transition>
            </div>

            <!-- All Shows Button -->
            <div class="col-12 d-flex align-items-center justify-content-center pt-5 pb-5">
                <a :href="`${$TICKETS_URL}`">
                    <div class="btn px-3 text-uppercase dark-btn" type="button">All shows & Events</div>
                </a>
            </div>
        </div>
    </div>
</template>


<script>
import { useRouter } from 'vue-router';

export default {
    name: 'AllShows',
    props: {
        showsData: {
            type: Array,
            default: () => []
        }
    },
    setup() {
        return {
            router: useRouter()
        };
    },
    data() {
        return {
            showPreviousShows: false,
        };
    },
    computed: {
        regularShows() {
            if (!this.showsData) return [];
            return this.showsData.filter(show => show.regular_show === true);
        },
        specialtyShows() {
            if (!this.showsData) return [];
            return this.showsData.filter(show => show.regular_show !== true && show.previous_show !== true);
        },
        previousShows() {
            if (!this.showsData) return [];
            return this.showsData.filter(show => show.previous_show === true);
        }
    },
    methods: {
        goToShow(show) {
            if (show.name && show.name.toLowerCase().includes('up all night jam')) {
                this.router.push('/jam');
            } else if (show.fw_link) {
                if (show.fw_link.includes('crowdwork.com') && typeof window.gtag === 'function') {
                    window.gtag('event', 'connect_to_CW', {
                        link_url: show.fw_link,
                        link_text: show.name || 'Buy Tickets',
                        page_path: window.location.pathname + window.location.search
                    });
                }
                window.location.href = show.fw_link;
            }
        },
        getShowLink(show) {
            if (show.name && show.name.toLowerCase().includes('up all night jam')) {
                return '/jam';
            }
            if (show.name && show.name.toLowerCase() === 'the cut') {
                return 'https://atlasimprov.com/thecut/';
            }
            return show.fw_link || '#';
        },
        getButtonText(show) {
            if (show.name && show.name.toLowerCase().includes('up all night jam')) {
                return 'Learn More';
            }
            if (show.name && show.name.toLowerCase() === 'the cut') {
                return 'Learn More';
            }
            return show.learn_more ? 'Learn More' : 'Buy Tickets';
        },
        getBackgroundColor(index) {
            const colors = ['#017B4A', '#1DB1D9', '#BB4A8C'];
            return { backgroundColor: colors[index % colors.length] };
        },
        observeCards() {
            if (this._cardObserver) this._cardObserver.disconnect();
            const cards = this.$el.querySelectorAll('.show-card');
            this._cardObserver = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('show-card--visible');
                        this._cardObserver.unobserve(entry.target);
                    }
                });
            }, { threshold: 0.1 });
            cards.forEach(card => this._cardObserver.observe(card));
        }
    },
    updated() {
        this.$nextTick(() => this.observeCards());
    },
    mounted() {
        this.observeCards();
    },
    beforeUnmount() {
        if (this._cardObserver) this._cardObserver.disconnect();
    }
};
</script>

<style scoped>
.prev-shows-enter-active {
    transition: max-height 0.45s ease, opacity 0.45s ease;
    overflow: hidden;
    max-height: 5000px;
}
.prev-shows-leave-active {
    transition: max-height 0.35s ease, opacity 0.35s ease;
    overflow: hidden;
    max-height: 5000px;
}
.prev-shows-enter-from,
.prev-shows-leave-to {
    max-height: 0;
    opacity: 0;
}

.show-card {
    opacity: 0;
    transform: translateY(28px);
    transition: opacity 0.5s ease, transform 0.5s ease;
}

.show-card--visible {
    opacity: 1;
    transform: translateY(0);
}

/* Keep the card text above the badges, which dip down (bottom: -15%) into this area */
.show-card .text-start {
    position: relative;
    z-index: 2;
}
</style>
